import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/images/log3.png";

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const toggleFullscreen = () => {
    if (location.pathname === '/fullscreen') {
      navigate('/');
    } else {
      navigate('/fullscreen');
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo">
          <img
            src={logo}
            alt="Metal Kıymetli Madenler Logo"
            className="navbar-logo-image"
          />
        </Link>

        {/* Menü */}
        <div className={`navbar-menu ${isMenuOpen ? "menu-open" : ""}`}>
          <ul className="menu">
            <li>
              <Link
                to="/"
                className={`menu-item ${location.pathname === "/" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Ana Sayfa
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={`menu-item ${location.pathname === "/about" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Hakkımızda
              </Link>
            </li>
            <li>
              <Link
                to="/products"
                className={`menu-item ${location.pathname === "/products" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Ürünlerimiz
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`menu-item ${location.pathname === "/contact" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                İletişim
              </Link>
            </li>
            <li>
              <a
                href="https://www.metalaltin.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="menu-item online-sales"
                onClick={() => setIsMenuOpen(false)}
              >
                <svg
                  className="cart-icon"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 2V4H3L6.6 11.59L5.25 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H19V15H7.42C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H5.21L4.27 2H1ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
                    fill="currentColor"
                  />
                </svg>
                Online Satış
              </a>
            </li>
          </ul>
        </div>

        {/* Fullscreen and Menu buttons */}
        <div className="navbar-right">
          <button
            className={`fullscreen-toggle ${location.pathname === '/fullscreen' ? 'active' : ''}`}
            onClick={toggleFullscreen}
            aria-label="Toggle fullscreen"
          >
            ⛶
          </button>
          <button
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            {isMenuOpen ? "✖" : "☰"}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
